import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const hasConsented = localStorage.getItem('cookie_consent_accepted');
        if (!hasConsented) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent_accepted', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: 'var(--card-bg-color, #1f2937)',
            color: 'var(--text-color, #f3f4f6)',
            padding: '15px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1)',
            zIndex: 9999,
            flexWrap: 'wrap',
            gap: '15px'
        }}>
            <div style={{ flex: '1 1 300px', fontSize: '14px', lineHeight: '1.5' }}>
                We use cookies to enhance your ordering experience and serve relevant content. By using our site, you agree to our <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color, #ea580c)' }}>Privacy Policy</a>.
            </div>
            <button 
                onClick={handleAccept}
                style={{
                    backgroundColor: 'var(--primary-color, #ea580c)',
                    color: '#fff',
                    border: 'none',
                    padding: '8px 24px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    flexShrink: 0
                }}
            >
                Accept
            </button>
        </div>
    );
};

export default CookieConsent;
